import React from 'react';
const CHECKOUT_URL = 'https://betterdailyguides.com/cart/51925795668270:1';
interface FinalCTASectionProps {
  onBuyClick: (e: React.MouseEvent) => void;
}
export function FinalCTASection({
  onBuyClick
}: FinalCTASectionProps) {
  return <section className="bg-gradient-to-br from-[#3D2B1F] to-[#6B4C3B] text-[#FAF7F2] py-16 px-5 text-center" data-id="element-51">
      <div className="max-w-[900px] mx-auto" data-id="element-52">
        <h2 className="text-4xl md:text-5xl text-[#FAF7F2] mb-4" data-id="element-53">
          Your Baby Can't Wait.
        </h2>

        <p className="text-lg text-[rgba(250,247,242,0.8)] font-sans max-w-[600px] mx-auto mb-9 leading-relaxed" data-id="element-54">
          Every day that passes without the right system is a neurological
          window that closes. The first year does not repeat. The decision is
          now.
        </p>

        <a href={CHECKOUT_URL} onClick={onBuyClick} className="inline-block bg-gradient-to-r from-[#C9A96E] to-[#B76E79] text-white text-lg font-bold py-5 px-12 rounded-full tracking-wide shadow-xl hover:shadow-2xl transition-all hover:-translate-y-1 font-sans uppercase animate-cta-pulse mb-6" data-id="element-55">
          ⚡ ACTIVATE MY FULL ACCESS FOR $12.97 →
        </a>

        <div className="flex justify-center gap-5 flex-wrap text-xs text-[rgba(250,247,242,0.6)] font-sans" data-id="element-56">
          <span className="flex items-center gap-1.5" data-id="element-57">
            🔒 Secure SSL Payment
          </span>
          <span className="flex items-center gap-1.5" data-id="element-58">📥 Immediate Access</span>
          <span className="flex items-center gap-1.5" data-id="element-59">↩️ 30-Day Guarantee</span>
        </div>
      </div>
    </section>;
}